import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import QS from 'qs'

import { parseJWT } from 'utils/auth'
import { signup } from 'utils/io'
import { getReferral } from 'utils/rewardful'
import { setCurrentUserToken } from 'ducks/users'

import AuthPage from './AuthPage'
import SignupForm from './SignupForm'

class Signup extends Component {
  constructor(props) {
    super(props)

    const { location } = props

    const { token, redirect } = QS.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    let initialValues = {}
    let error = null

    if (token) {
      const tokenBody = parseJWT(token)

      if (tokenBody) {
        initialValues = { email: tokenBody.email }
      } else {
        error = 'Your invitation has expired. Invitations expire after 7 days.'
      }
    }

    this.state = {
      initialValues,
      error,
      inviteToken: token,
      redirect,
    }
  }

  handleSubmit = values =>
    new Promise((resolve, reject) => {
      const { history, setCurrentUserToken } = this.props
      let { inviteToken, redirect } = this.state
      const rewardfulToken = getReferral()

      // for hubspot
      const pageUri = window.location.href
      const pageName = document.title

      const cookies = Object.fromEntries(
        document.cookie.split('; ').map(c => {
          const [key, ...v] = c.split('=')

          return [key, v.join('=')]
        })
      )

      const hubspotutk = cookies?.hubspotutk

      const data = {
        ...values,
        inviteToken,
        rewardfulToken,
        hubspotutk,
        pageUri,
        pageName,
      }

      signup(data, ({ success, errors, sessionToken, newOrg }) => {
        if (!success) {
          return reject(new SubmissionError(errors))
        }

        // set user token
        window.localStorage.setItem('protonSession', sessionToken)
        setCurrentUserToken(sessionToken)

        if (redirect) {
          if (!String(redirect).startsWith('/')) redirect = `/${redirect}`
          history.push(redirect)
        } else if (newOrg) {
          // TODO: This is where the trial stuff happens
          // NOTE: This is disabled with the following line:
          // history.push('/team-setup')
          history.push('/first-app-setup')
        } else {
          history.push('/')
        }

        resolve()
      })
    })

  render() {
    const { children, location } = this.props
    const { redirect } = this.state
    const isInvite = location.pathname === '/accept-invite'

    const { initialValues, error } = this.state

    return (
      <AuthPage name="signup-page" error={error}>
        <SignupForm
          isInvite={isInvite}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          redirect={redirect}
        />
        {children}
      </AuthPage>
    )
  }
}

export default connect(null, { setCurrentUserToken })(Signup)
